import { type yup } from '@framework/validation/initYup.ts';
import { type ExpressionValue } from '../../../../expressions/evaluate/ExpressionValue.ts';
import { evaluateExpression } from '../../../../expressions/evaluate/evaluateExpression.ts';
import { type IParentWidgetScope } from '../../../IWidgetType.ts';
import { type IComputedDateWidget } from '../IComputedWidget.ts';
import { setComputeTransform } from '../setComputedTransform.ts';

export function setComputedDateTransform(
  widget: Pick<IComputedDateWidget, 'expression'>,
  parentScope: IParentWidgetScope,
  schema: yup.AnySchema,
  /**
   * Funzione di trasformazione del risultato dell'espressione.
   */
  transform?: (value: ExpressionValue) => any,
) {
  return setComputeTransform(
    widget.expression,
    parentScope,
    schema,
    (expression, variables) => {
      const result = evaluateExpression(expression, { variables });

      return transform ? transform(result) : result;
    },
  );
}
